import { defineComponent, createVNode, Fragment, isVNode } from "vue";
import { p as prefix } from "./chunks/config.mjs";
import { g as getSlot } from "./chunks/vue-tsx.mjs";
import { M as MdModal } from "./chunks/index3.mjs";
function _isSlot(s) {
  return typeof s === "function" || Object.prototype.toString.call(s) === "[object Object]" && !isVNode(s);
}
const props = {
  title: {
    type: String,
    default: ""
  },
  modalTitle: {
    type: String,
    default: ""
  },
  visible: {
    type: Boolean
  },
  width: {
    type: String,
    default: "auto"
  },
  height: {
    type: String,
    default: "auto"
  },
  // 展示在工具栏的内容，通常是个图标
  trigger: {
    type: [String, Object]
  },
  onClick: {
    type: Function
  },
  onClose: {
    type: Function
  },
  /**
   * 显示全屏按钮
   */
  showAdjust: {
    type: Boolean,
    default: false
  },
  isFullscreen: {
    type: Boolean,
    default: false
  },
  onAdjust: {
    type: Function
  },
  /**
   * ==没有意义，仅用于规避克隆组件自动嵌入insert方法时，传入的是该组件而产生的waring
   */
  insert: {
    type: Function
  },
  language: {
    type: String
  },
  theme: {
    type: String
  },
  previewTheme: {
    type: String
  }
  /**
   * ==结束
   */
};
const ModalToolbar = /* @__PURE__ */ defineComponent({
  name: "ModalToolbar",
  props,
  emits: ["onClick", "onClose", "onAdjust"],
  setup(props2, ctx) {
    return () => {
      const Trigger = getSlot({
        props: props2,
        ctx
      }, "trigger");
      const Default = getSlot({
        props: props2,
        ctx
      }, "default");
      return createVNode(Fragment, null, [createVNode("div", {
        "class": `${prefix}-toolbar-item`,
        "title": props2.title,
        "onClick": () => {
          if (props2.onClick instanceof Function) {
            props2.onClick();
          } else {
            ctx.emit("onClick");
          }
        }
      }, [Trigger]), createVNode(MdModal, {
        "width": props2.width,
        "height": props2.height,
        "title": props2.modalTitle,
        "visible": props2.visible,
        "onClose": () => {
          if (props2.onClose instanceof Function) {
            props2.onClose();
          } else {
            ctx.emit("onClose");
          }
        },
        "showAdjust": props2.showAdjust,
        "isFullscreen": props2.isFullscreen,
        "onAdjust": (v) => {
          if (props2.onAdjust instanceof Function) {
            props2.onAdjust(v);
          } else {
            ctx.emit("onAdjust", v);
          }
        }
      }, _isSlot(Default) ? Default : {
        default: () => [Default]
      })]);
    };
  }
});
ModalToolbar.install = (app) => {
  app.component(ModalToolbar.name, ModalToolbar);
  return app;
};
export {
  ModalToolbar as default
};
